module.exports = __webpack_public_path__ + "static/media/taeil-7.jpeg";